{
  "title": "Mordenkainen's Private Sanctum",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a thin sheet of lead, a piece of opaque glass, a wad of cotton or cloth, and powdered chrysolite)",
  "duration": "24 hours",
  "description": [
    "You make an area within range magically secure. The area is a cube that can be as small as 5 feet to as large as 100 feet on each side. The spell lasts for the duration or until you use an action to dismiss it.",
    "When you cast the spell, you decide what sort of security the spell provides, choosing any or all of the following properties:",
    "Sound can’t pass through the barrier at the edge of the warded area.",
    "The barrier of the warded area appears dark and foggy, preventing vision (including darkvision) through it.",
    "Sensors created by divination spells can’t appear inside the protected area or pass through the barrier at its perimeter.",
    "Creatures in the area can’t be targeted by divination spells.",
    "Nothing can teleport into or out of the warded area.",
    "Planar travel is blocked within the warded area.",
    "Casting this spell on the same spot every day for a year makes this effect permanent.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, you can increase the size of the cube by 100 feet for each slot level beyond 4th. Thus you could protect a cube that can be up to 200 feet on one side by using a spell slot of 5th level."
  ],
  "spellLists": ["artificer", "eldritch-knight", "wizard"]
}
